import styled from 'styled-components';

export const FlexContainer = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 8px;
  min-width: 100%;
`;

export const Row = styled.div`
  display: flex;
`;
